import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { merchantApi } from "@api";
import { ArrowLeftColor, IConClose, SharedInput } from "@components";
import { PATH_HOME } from "@configs";
import {
    IAddressData,
    IAmphur,
    IConfirmMisson,
    IDisplay,
    IMemberTier,
    IMission,
    IProvince,
    ISubDistrict,
} from "@interfaces";
import { fetchUser, getMission, selectApp, selectAuth, selectMerchant } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, RenderMeta, useNotify } from "@utils";
import { Col, Progress, Row, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useFullScreen } from "src/Helpers/useFullscreen";
import CountdownTimer from "./shared/CountDownTimer";
import { Redeemed } from "./shared/Redeemed";

const { Option } = Select;

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

interface IFocusDetail {
    mIndex: number;
    daysLeft: number;
    beforeDate: number;
}

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};

export const ComponentMission = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    //push route
    const history = useHistory();
    const { warning, error, success } = useNotify();
    //page props
    const { avatar, fullName, memberTier, isConfirm } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { missionDisplaySetting } = useSelector(selectMerchant);
    const { langSetting } = useSelector(selectApp);
    const [isLoading, setIsloading] = useState(true);

    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [missionList, setMissionList] = useState<IMission[]>([]);
    const [focusDetail, setFocusDetail] = useState<IFocusDetail>({
        mIndex: 0,
        daysLeft: 0,
        beforeDate: 0,
    });
    const today = new Date();
    const [resultData, setResultData] = useState<any>();
    const [reload, setReload] = useState<boolean>(true);

    const [rewardData, setRewardData] = useState<any>();
    const [isCompactSafari, setIsCompactSafari] = useState(false);

    const [display, setDisplay] = useState<IDisplay>({
        province: "",
        district: "",
        subDistrict: "",
    });
    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [subDistrictIndex, setSubDistrictIndex] = useState<number>(0);
    const [showAddr, setShowAddr] = useState(false);
    // let missionList: IMission[] = missionDisplaySetting?.missions || [];

    // const [surveyList, setSurveyList] = useState<ISurvey[]>([]);

    // useEffect(() => {
    //     fetchSurvey();
    // }, []);

    // const fetchSurvey = async () => {
    //     let res = await merchantApi.getSurveyList();
    //     if (res.data.length > 0) {
    //         setSurveyList(res?.data);
    //     }
    // };

    useEffect(() => {
        dispatch(getMission());
    }, []);

    useEffect(() => {
        fetchMission();
    }, [missionDisplaySetting]);

    useEffect(() => {
        const detectCompactSafari = () => {
            if (typeof window === "undefined" || typeof navigator === "undefined") {
                return;
            }

            const userAgent = navigator.userAgent || "";
            const platform = navigator.platform || "";
            const isIOS =
                /iPad|iPhone|iPod/.test(platform) ||
                (userAgent.includes("Mac") && navigator.maxTouchPoints > 1);
            const isSafari =
                /Safari/i.test(userAgent) &&
                !/Chrome|CriOS|FxiOS|OPiOS|EdgiOS|YaBrowser|UCBrowser/i.test(userAgent);
            const isSmallScreen = window.innerHeight <= 700 || window.innerWidth <= 375;

            setIsCompactSafari(Boolean(isIOS && isSafari && isSmallScreen));
        };

        detectCompactSafari();
        window.addEventListener("resize", detectCompactSafari);
        return () => {
            window.removeEventListener("resize", detectCompactSafari);
        };
    }, []);

    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [showpopuppage, setShowPopupPage] = useState(true);

    const getExpireDate = (mItem: IMission, isList?: boolean) => {
        if (mItem.is_validity_claim_enddate && mItem.validity_claim_enddate_date && !isList) {
            const expireDateTime = `${mItem.validity_claim_enddate_date} ${
                mItem.validity_claim_enddate_time || "00:00"
            }`;
            const parsed = dayjs(expireDateTime, "YYYY-MM-DD HH:mm")?.add(1, "minute");
            return parsed.isValid() ? parsed.toDate() : null;
        }

        if (mItem.validity_datetime_to_string) {
            const parsed = dayjs(mItem.validity_datetime_to_string)?.add(1, "minute");
            return parsed.isValid() ? parsed.toDate() : null;
        }

        return null;
    };

    const getBeforDateFormMission = (mItem: IMission) => {
        if (mItem?.validity_datetime_from_string) {
            const parsed = dayjs(mItem.validity_datetime_from_string);
            return parsed.isValid() ? parsed.toDate() : null;
        }

        return null;
    };

    const calculateDaysLeft = (mItem: IMission, isList?: boolean) => {
        const expireDate = getExpireDate(mItem, isList);
        if (!expireDate) return 0;
        const timeDifference = expireDate.getTime() - today.getTime();
        return Math.ceil(timeDifference / (1000 * 3600 * 24));
    };

    const calculateDaysBefore = (mItem: IMission) => {
        const startDate = getBeforDateFormMission(mItem);
        if (!startDate) return 0;

        const timeDifference = startDate.getTime() - today.getTime();
        return Math.ceil(timeDifference / (1000 * 3600 * 24));
    };

    const getMissionStatusText = (mItem?: IMission, isList?: boolean) => {
        if (!mItem) return "";
        const startDate = getBeforDateFormMission(mItem);
        if (startDate && today < startDate) {
            return `Start at ${dayjs(startDate).format("YYYY-MM-DD HH:mm")}`;
        }

        const daysLeft = calculateDaysLeft(mItem, isList);
        return daysLeft > 0 ? `${daysLeft} days left` : "expired";
    };

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
        setShowAddr(false);
    };

    const fetchMission = () => {
        setMissionList(missionDisplaySetting?.missions || []);
        setIsloading(false);
        // let resDetail = await merchantApi.getRewardDetails("66b055a05c41c10311cdd0f2");
        // console.log("resDetail", resDetail);
    };

    const getRewardDetails = async (rewardId: string) => {
        let res = await merchantApi.getRewardDetails(rewardId);
        setRewardData(res?.data);
    };

    const currentMission = missionList?.[focusDetail?.mIndex];
    const currentDaysLeft = currentMission ? calculateDaysLeft(currentMission) : 0;
    const isMissionExpired = currentDaysLeft <= 0;
    const isMissionIncomplete = (currentMission?.percent_complete ?? 0) < 100;
    const isMissionClaimed = currentMission?.status === "claimed";
    const isRedeemDisabled = isMissionIncomplete || isMissionExpired;

    const clickMission = (mIndex: number) => {
        let mItem = missionList[mIndex];
        let daysLeft = calculateDaysLeft(mItem);
        let beforeDate = calculateDaysBefore(mItem);
        setFocusDetail({
            mIndex: mIndex,
            daysLeft: daysLeft,
            beforeDate: beforeDate,
        });
        getRewardDetails(mItem?.reward_list?.[0]?.reward_id || "");
    };

    const clickConfirm = async () => {
        await null;
        let proObj = provinceList.find((item) => item?.province_id === addressData.province);
        let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
        let addDisplay = {
            province: proObj?.province_name_tha || "",
            district: disObj?.amphur_name_tha || "",
            subDistrict: subObj?.district_name_tha || "",
        };
        let shipText = [
            addressData?.address,
            addDisplay?.province,
            addDisplay?.district,
            addDisplay?.subDistrict,
            addressData?.postCode,
        ].join(" ");
        let payload: IConfirmMisson = {
            id: missionList?.[focusDetail?.mIndex]?.reward_list?.[0]?.reward_id || "",
            pos_profile_mission_id:
                missionList?.[focusDetail?.mIndex]?.pos_profile_mission_id || "",
            profile_id: userInfo?._id || "",
            ...(rewardData?.isDelivery && { shippingAddress: shipText }),
            // shippingAddress: rewardData?.isDelivery ? shipText : "",
        };

        try {
            UIStore.setState({ isLoading: true });
            let res = await merchantApi.confirmReward(payload);

            if (res?.data?.error === "0" || !res?.data?.error) {
                setResultData(res?.data);
                setShowPage4(false);
                setShowResult(true);
                setShowPopupPage(true);
                setReload(!reload);
                dispatch(getMission());
                dispatch(fetchUser());
                UIStore.setState({ isLoading: false });
            } else {
                error(formatMessage(res?.data?.msg));
                UIStore.setState({ isLoading: false });
            }
        } catch (err: any) {
            UIStore.setState({ isLoading: false });
            if (err.response) {
                error(formatMessage(err.response));
            }
        }
    };

    useEffect(() => {
        if (userInfo) {
            const firstFetchAddress = async () => {
                if (userInfo?.contact?.address) {
                    await getAmphur(parseInt(userInfo?.contact?.address?.province));
                    await getSubDistrictByamphur(parseInt(userInfo?.contact?.address?.district));

                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        // subDistrict: userInfo?.contact?.address?.subDistrict,
                        subDistrict: subDistrictIndex !== -1 ? subDistrictIndex.toString() : "",
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);
                }
            };
            firstFetchAddress();
        }
    }, []);

    const openAddress = () => {
        let provinceListNew = provinceList;
        if (provinceListNew === undefined || provinceListNew === null) {
            provinceListNew = [];
        }
        let amphurListNew = amphurList;
        if (amphurListNew === undefined || amphurListNew === null) {
            amphurListNew = [];
        }
        let subDistrictListNew = subDistrictList;
        if (subDistrictListNew === undefined || subDistrictListNew === null) {
            subDistrictListNew = [];
        }
        let proObj = provinceListNew.find((item) => item?.province_id === addressData.province);
        let disObj = amphurListNew.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictListNew[parseInt(addressData?.subDistrict)];

        if (proObj !== undefined && disObj !== undefined && subObj !== undefined) {
            setDisplay({
                province: proObj?.province_name_tha || "",
                district: disObj?.amphur_name_tha || "",
                subDistrict: subObj?.district_name_tha || "",
            });
        }
        setShowPage1(false);
        setShowAddr(true);
    };

    useEffect(() => {
        getAllProvince();
    }, []);

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        setSubDistrictIndex(
            subRes.data.result.findIndex(
                (item: any) => item?.district_id === userInfo?.contact?.address?.subDistrict
            )
        );
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0]?.province_id || "";
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };

    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const onChangeSubDistrict = (value: any) => {
        let outSub = subDistrictList[value];
        setAddressData({
            ...addressData,
            subDistrict: value,
            postCode: outSub?.zipcode,
        });
    };

    const fullHeight = useFullScreen();
    const isDeliveryAddressComplete =
        Boolean(String(addressData.address ?? "").trim()) &&
        Boolean(String(addressData.province ?? "").trim()) &&
        Boolean(String(addressData.district ?? "").trim()) &&
        Boolean(String(addressData.subDistrict ?? "").trim()) &&
        Boolean(String(addressData.postCode ?? "").trim());

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={true}
                active
                title={true}
                paragraph={{ rows: 3, width: [220, 220, 54] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                active
                title={true}
                paragraph={{ rows: 3, width: [220, 220, 54] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                active
                title={true}
                paragraph={{ rows: 3, width: [220, 220, 54] }}
            ></Skeleton>
        </StyledSkeleton>
    );

    return (
        <>
            <RenderMeta title="Mission page" />
            {merchant?.missionDisplaySetting?.displaySetting?.backgroundImage === "" ? null : null}
            <StyledMission
                themeColor={themes?.themeColor!}
                bgImg={merchant?.missionDisplaySetting?.displaySetting?.backgroundImage!}
                contentColor={merchant?.missionDisplaySetting?.displaySetting?.shadingColor!}
                style={{ height: fullHeight }}
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            color={themes?.themeColor}
                            onClick={() => history.push(PATH_HOME)}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                    {/* <div className="logo-survey">
                        <img src="../images/logo-survey.svg" alt="" />
                        Survey
                    </div> */}
                </header>
                <div className="title-section">
                    <img
                        className="title-img"
                        src={
                            merchant?.missionDisplaySetting?.displaySetting?.icon ||
                            "../images/mission_header.png"
                        }
                        alt=""
                    />
                </div>

                <div className="layout-main-mission">
                    <div className="layout-header-mission">
                        <div className="img-header-mission">
                            <img
                                src={
                                    merchant?.missionDisplaySetting?.displaySetting
                                        ?.backgroundModel || "../images/mission_header.png"
                                }
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="layout-box-mission">
                        {isLoading === false ? (
                            <>
                                {missionList?.map((mItem: IMission, mIndex: number) => {
                                    let daysLeft = calculateDaysLeft(mItem);
                                    return (
                                        <div
                                            className={
                                                "box-mission " +
                                                (mItem?.percent_complete >= 100 && "claim")
                                            }
                                            key={mIndex}
                                            onClick={() => {
                                                setShowPopup(true);
                                                clickMission(mIndex);
                                            }}
                                        >
                                            <h2>{mItem?.pos_mission_name}</h2>
                                            <div className="detail-box-mission">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: mItem?.remark,
                                                    }}
                                                ></p>
                                                <Progress
                                                    percent={Math.floor(mItem?.percent_complete)}
                                                    showInfo={true}
                                                />
                                                <span>{getMissionStatusText(mItem, true)}</span>
                                            </div>
                                            <div className="layout-img-mission">
                                                <div className="box-img-mission">
                                                    <img
                                                        src={
                                                            mItem?.reward_list?.[0]?.image_url ||
                                                            "../images/img-mission-01.png"
                                                        }
                                                        alt=""
                                                    />
                                                    {mItem?.percent_complete >= 100 &&
                                                        mItem?.status === "pending" &&
                                                        daysLeft > 0 && (
                                                            <div className="box-claim">Claim</div>
                                                        )}
                                                    {mItem?.status === "claimed" && (
                                                        <div className="box-claim claimed">
                                                            Claimed
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        ) : (
                            <>
                                {missionList?.length === 0 && isLoading ? (
                                    loadingComponent
                                ) : (
                                    <div className="nodata">
                                        <p>ยังไม่มีรายการ</p>
                                        <p>No records to display</p>
                                        {/* {loadingComponent} */}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </StyledMission>

            {isShowPopup && (
                <StyledShowPopup themeColor={themes?.themeColor!} isCompactSafari={isCompactSafari}>
                    <div className="page-wrapper">
                        <div className="close" onClick={handleCloseDetail}>
                            <IConClose width={16} />
                        </div>
                        {showpopuppage ? (
                            <div className="content-layout">
                                <div className="content">
                                    {showpage1 ? (
                                        <>
                                            <div className="header-product">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img
                                                            src={
                                                                missionList?.[focusDetail?.mIndex]
                                                                    ?.reward_list?.[0]?.image_url ||
                                                                "../images/img-detail-mission.png"
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="topic-product">
                                                    {
                                                        missionList?.[focusDetail?.mIndex]
                                                            ?.pos_mission_name
                                                    }
                                                </div>

                                                <div className="process-product">
                                                    <Progress
                                                        percent={
                                                            missionList?.[focusDetail?.mIndex]
                                                                ?.percent_complete
                                                        }
                                                        showInfo={false}
                                                    />
                                                </div>
                                                <div className="expier-product">
                                                    {/* Limit Redeem : 1 User / Day */}
                                                    <span>
                                                        {getMissionStatusText(
                                                            missionList?.[focusDetail?.mIndex],
                                                            false
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="content-product">
                                                <div className="topic-detail">
                                                    {t("page.conditions")}
                                                </div>
                                                <div className="layout-giftset">
                                                    <div className="img-giftset">
                                                        <img
                                                            src={
                                                                missionList?.[focusDetail?.mIndex]
                                                                    ?.reward_list?.[0]?.image_url ||
                                                                "../images/img-giftset.png"
                                                            }
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="text-giftset">
                                                        <h2>
                                                            {missionList?.[focusDetail?.mIndex]
                                                                ?.reward_list?.[0]?.reward_name ||
                                                                "Reward"}
                                                        </h2>
                                                        <p>
                                                            {missionList?.[focusDetail?.mIndex]
                                                                ?.remark || "Reward"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <p>{/* condition */}</p>
                                            </div>
                                            <StyledUsedBtn
                                                className={
                                                    "btn-redeem " +
                                                    (isRedeemDisabled ? " disabled " : "") +
                                                    (isMissionClaimed ? " claimed " : "")
                                                }
                                                themeColor={themes?.themeColor!}
                                                disabled={isRedeemDisabled}
                                                onClick={() => {
                                                    if (!isRedeemDisabled && !isMissionClaimed) {
                                                        if (rewardData?.isDelivery) {
                                                            openAddress();
                                                        } else {
                                                            setShowPage1(false);
                                                            setShowPage4(true);
                                                            setShowPopupPage(false);
                                                        }
                                                    }
                                                }}
                                            >
                                                {isMissionClaimed
                                                    ? " claimed "
                                                    : t("page.claimreward")}
                                            </StyledUsedBtn>
                                        </>
                                    ) : null}
                                    {showAddr && (
                                        <>
                                            {/* <StyledSurvey mainColor={themes?.themeColor!}> */}
                                            <br />
                                            <div className="header-product">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img
                                                            src={
                                                                missionList?.[focusDetail?.mIndex]
                                                                    ?.reward_list?.[0]?.image_url ||
                                                                "../images/img-detail-mission.png"
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="topic-product">
                                                    {
                                                        missionList?.[focusDetail?.mIndex]
                                                            ?.pos_mission_name
                                                    }
                                                </div>

                                                <div className="process-product">
                                                    <Progress
                                                        percent={
                                                            missionList?.[focusDetail?.mIndex]
                                                                ?.percent_complete
                                                        }
                                                        showInfo={false}
                                                    />
                                                </div>
                                                <div className="expier-product">
                                                    {/* Limit Redeem : 1 User / Day */}
                                                    <span>
                                                        {focusDetail?.daysLeft > 0
                                                            ? focusDetail?.daysLeft + " days left"
                                                            : "expired"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="topic-detail">{"Shipping Address"}</div>
                                            <br />
                                            <div className="layout-address">
                                                <div className="box-address">
                                                    <SharedInput
                                                        name="freeTextAnswer"
                                                        value={addressData?.address}
                                                        onChange={(
                                                            e: React.ChangeEvent<HTMLFormElement>
                                                        ) =>
                                                            setAddressText(
                                                                e.target.value,
                                                                "address"
                                                            )
                                                        }
                                                        placeholder={t("page.address")}
                                                    />
                                                </div>
                                                <div className="box-address">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.province")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.county")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeProvince}
                                                                value={
                                                                    addressData.province === ""
                                                                        ? undefined
                                                                        : addressData.province
                                                                }
                                                                placeholder={t("page.province")}
                                                            >
                                                                {provinceList?.length > 0 &&
                                                                    provinceList?.map(
                                                                        (pItem, pIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={
                                                                                        pItem?.province_id
                                                                                    }
                                                                                    key={pIndex}
                                                                                >
                                                                                    {
                                                                                        pItem.province_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeAmphur}
                                                                value={
                                                                    addressData.district === ""
                                                                        ? undefined
                                                                        : addressData.district
                                                                }
                                                                placeholder={t("page.county")}
                                                            >
                                                                {amphurList?.length > 0 &&
                                                                    amphurList?.map(
                                                                        (aItem, aIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={
                                                                                        aItem?.amphur_id
                                                                                    }
                                                                                    key={aIndex}
                                                                                >
                                                                                    {
                                                                                        aItem?.amphur_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="box-address">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.district")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <p className="input-title ">
                                                                {t("page.zipcode")}
                                                            </p>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select
                                                                onChange={onChangeSubDistrict}
                                                                value={
                                                                    addressData.subDistrict === ""
                                                                        ? undefined
                                                                        : parseInt(
                                                                              addressData.subDistrict
                                                                          )
                                                                }
                                                                placeholder={t("page.district")}
                                                            >
                                                                {subDistrictList?.length > 0 &&
                                                                    subDistrictList?.map(
                                                                        (sItem, sIndex) => {
                                                                            return (
                                                                                <Option
                                                                                    value={sIndex}
                                                                                    key={sIndex}
                                                                                >
                                                                                    {
                                                                                        sItem?.district_name_tha
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                            </Select>
                                                        </Col>
                                                        <Col span={12}>
                                                            <SharedInput
                                                                name="freeTextAnswer"
                                                                value={addressData?.postCode}
                                                                onChange={(
                                                                    e: React.ChangeEvent<HTMLFormElement>
                                                                ) =>
                                                                    setAddressText(
                                                                        e.target.value,
                                                                        "postCode"
                                                                    )
                                                                }
                                                                styleParent={{ height: "48px" }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    border: "1px solid gray",
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            <br />
                                            <StyledUsedBtn
                                                className="btn-redeem"
                                                themeColor={themes?.themeColor!}
                                                disabled={
                                                    rewardData?.isDelivery &&
                                                    !isDeliveryAddressComplete
                                                }
                                                onClick={() => {
                                                    setShowPage1(false);
                                                    setShowAddr(false);
                                                    setShowPage4(true);
                                                    setShowPopupPage(false);
                                                }}
                                            >
                                                {t("page.confirm")}
                                            </StyledUsedBtn>
                                            <br />
                                            <br />
                                            {/* </StyledSurvey> */}
                                        </>
                                    )}

                                    {showresult ? (
                                        <>
                                            <div className="content-info">
                                                <div className="header-product">
                                                    <div className="layout-img">
                                                        <div className="img-product">
                                                            <img
                                                                src={
                                                                    resultData?.reward_list?.[0]
                                                                        ?.image_url ||
                                                                    "../images/img-detail-mission.png"
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="topic-product">
                                                        {resultData?.pos_mission_name}
                                                    </div>
                                                    <div className="expier-product">
                                                        {/* Limit Redeem : 1 User / Day */}
                                                    </div>

                                                    {resultData?.reward?.reward?.autoUseTimeOut && (
                                                        <div className="countdownBox">
                                                            <CountdownTimer
                                                                targetDate={
                                                                    resultData?.reward?.reward
                                                                        ?.autoUseTimeOut
                                                                }
                                                            />
                                                            <div style={{ textAlign: "center" }}>
                                                                The code will expire{" "}
                                                                {rewardData?.autoUseTime?.time}{" "}
                                                                {rewardData?.autoUseTime
                                                                    ?.timeUnit === "s"
                                                                    ? "seconds "
                                                                    : rewardData?.autoUseTime
                                                                          ?.timeUnit === "m"
                                                                    ? "minutes "
                                                                    : rewardData?.autoUseTime
                                                                          ?.timeUnit === "h"
                                                                    ? "hours "
                                                                    : " "}
                                                                after clicking the confirm button.
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="process-product">
                                                        <Progress percent={100} showInfo={false} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="action-layout">
                                                <div className="qr-layout">
                                                    <div className="qr-box">
                                                        <QRCode
                                                            value={
                                                                resultData?.ticketCodes?.[0] || ""
                                                            }
                                                            size={150}
                                                        />
                                                    </div>
                                                    <StyledCodeButton
                                                        mainColor={themes?.themeColor!}
                                                    >
                                                        {resultData?.ticketCodes[0] || "---"}
                                                    </StyledCodeButton>
                                                </div>
                                                <p className="redeemed-product">
                                                    <span className="redeemed">
                                                        <Redeemed color="#336C51" />
                                                    </span>
                                                    REDEEMED
                                                </p>
                                                <p className="note">{t("page.desConfirm")}</p>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                        {showpage4 ? (
                            <StyledPopupRedeem themeColor={themes?.themeColor!}>
                                <div className="box-popupconfirm">
                                    <div className="img-popupconfirm">
                                        <img
                                            src={
                                                merchant?.themes?.basicThemeSetting?.iconGeneral[0]
                                                    .image || ""
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="title">
                                        <div className="text-sub-header">
                                            {t("page.pleaseconfirm")}
                                        </div>
                                        {rewardData?.autoUseTime?.enabled ? (
                                            <div className="text-desc">
                                                The code will expire in{" "}
                                                {rewardData?.autoUseTime?.time}{" "}
                                                {rewardData?.autoUseTime?.timeUnit === "s"
                                                    ? "seconds "
                                                    : rewardData?.autoUseTime?.timeUnit === "m"
                                                    ? "minutes "
                                                    : rewardData?.autoUseTime?.timeUnit === "h"
                                                    ? "hours "
                                                    : " "}
                                                confirmation.
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="btn-popupconfirm">
                                        <StyledUsedBtn
                                            className="btn-cancel"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => {
                                                setShowPage4(false);
                                                setShowPage1(true);
                                                setShowPopupPage(true);
                                            }}
                                        >
                                            {t("page.cancel")}
                                        </StyledUsedBtn>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            disabled={
                                                rewardData?.isDelivery && !isDeliveryAddressComplete
                                            }
                                            onClick={() => {
                                                clickConfirm();
                                            }}
                                        >
                                            {t("page.confirm")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        ) : null}
                    </div>
                </StyledShowPopup>
            )}
        </>
    );
};

const StyledLoading = styled.div`
    // margin-top: 25px;
    padding: 0 24px;
    width: 100%;
    position: relative;
    z-index: 9;
    .card {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 1px 3px 6px rgba(0, 0, 0, 0.23);
        margin-bottom: 28px;
        background-color: ${(p) => p.theme.colors.card};
        display: flex;
        width: 100%;
        position: relative;
        flex-direction: column;
        .img {
            width: 100%;
            height: 170px;
            @media (max-width: 375px) {
                width: 100%;
                height: 130px;
            }
        }
        .content {
            display: flex;
            align-items: center;
            padding: 10px 0;
            .content {
                border-radius: 30px;
                margin: 0 20px;
            }
            .fix-layout-img {
                text-align: center;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 30%;
                .img {
                    width: 64px;
                    height: 64px;
                }
            }
            .fix-layout {
                width: 70%;
            }
        }
    }
`;

const StyledSkeleton = styled.div`
    .ant-skeleton {
        background-color: #e6e6e6;
        border-radius: 16px;
        padding: 10px 16px 0;
        margin-bottom: 16px;
        .ant-skeleton-title {
            margin-top: 12px;
            margin-bottom: 12px;
            height: 10px;
            border-radius: 4px;
        }
        .ant-skeleton-paragraph {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            li {
                margin-top: 0;
                margin-bottom: 12px;
                height: 10px;
                border-radius: 4px;
            }
        }
    }
`;

const StyledMission = styled.div<{ themeColor: string; bgImg: string; contentColor: string }>`
    width: 100%;
    margin: 0 auto;
    padding: 30px 15px;
    /* height: 100vh; */
    background-color: #fff;
    background-position: center top;
    background-repeat: no-repeat;
    background-image: ${(props) =>
        props?.bgImg !== "" ? `url(${props?.bgImg})` : "../../images/bg-main-mission-02.png"};
    background-size: cover;

    .nodata {
        // padding: 30px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
            font-size: 16px;
            color: #a5a5a5;
            line-height: 18px;
            margin-bottom: 5px;
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .title-section {
        text-align: center;
        margin-top: 1dvh;
        .title-img {
            width: 100%;
            // margin-bottom: 8dvh;
            max-width: 300px;
            max-height: 100px;
        }
    }

    .layout-main-mission {
        margin-top: 4dvh;
        background-color: #fff;
        background: linear-gradient(
            180deg,
            ${(props) => (props?.contentColor !== "" ? props?.contentColor : "rgba(255,255,255,1)")}
                50%,
            rgba(255, 255, 255, 0) 95%
        );
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        /* min-height: 75dvh; */
        height: calc(100% - 127px);

        .layout-header-mission {
            position: relative;
            padding: 30px 16px 5px;
            .img-header-mission {
                position: absolute;
                right: 0px;
                top: -50px;
                z-index: 9;
                img {
                    width: 165px;
                }
            }
        }
        .layout-box-mission {
            padding: 0 16px 16px;
            /* height: 73dvh; */
            height: calc(100% - 35px);
            overflow: scroll;
            overflow-x: hidden;

            .box-mission {
                /* background-color: rgba(196, 163, 99, 0.12); */
                background-color: #f2f2f2;
                border-radius: 12px;
                position: relative;
                margin-bottom: 8px;
                z-index: 10;
                padding: 12px 20px;

                h2 {
                    font-size: 18px;
                    line-height: 20px;
                    color: #000;
                    margin-bottom: 5px;
                    font-weight: 600;
                    padding-right: 80px;
                    width: 100%;
                    word-wrap: break-word;
                }
                .detail-box-mission {
                    padding-right: 80px;
                    position: relative;
                    p {
                        font-size: 12px;
                        line-height: 14px;
                        color: #525257;
                        margin-bottom: 7px;
                        min-height: 28px;
                        word-break: break-word;
                    }
                    span {
                        font-size: 10px;
                        color: #9b9b9b;
                        text-align: left;
                        display: block;
                    }
                    .ant-progress.ant-progress-show-info {
                        .ant-progress-outer {
                            margin-inline-end: 0;
                            padding-inline-end: 0;
                        }
                    }
                    .ant-progress-inner {
                        background-color: #fff;
                    }
                    .ant-progress-bg {
                        background-color: ${(p) => p.themeColor};
                    }
                    .ant-progress-text {
                        position: absolute;
                        right: 0;
                    }
                }
                .layout-img-mission {
                    position: absolute;
                    right: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                    .box-img-mission {
                        position: relative;
                        img {
                            width: 64px;
                            height: 64px;
                            object-fit: contain;
                            border-radius: 100%;
                            overflow: hidden;
                            background-color: #ddd;
                        }
                        .box-claim {
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: -15px;
                            display: flex;
                            padding: 5px 14px;
                            background-color: #11824a;
                            border-radius: 14px;
                            font-size: 12px;
                            color: #fff;
                            cursor: pointer;
                        }
                        .claimed {
                            background-color: lightgray;
                        }
                    }
                }
            }
        }
        .claim {
            border: 1px solid #11824a;
        }
    }
`;
const StyledPopupRedeem = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
        .text-desc {
            font-size: 11px;
            color: #000;
            font-weight: 400;
        }
    }
`;

const StyledAlienCode = styled.div<{ mainColor?: string }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    flex-direction: column;
    margin-bottom: 10px;
    .title {
        margin-bottom: 10px;
    }
    .alien-code-btn {
        color: #c4a363;
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        width: 100%;
        text-align: center;
        padding: 18px 0;
        background-color: #ddd;
        border-radius: 12px;
        background-image: url(../../images/bg-code.svg);
        background-size: cover;
    }
`;

const StyledCodeButton = styled.div<{ mainColor?: string }>`
    position: absolute;
    background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
        background: ${(p) => p.theme.colors.card};
        color: ${(p) => p.themeColor};
    }
`;

const StyledShowPopup = styled.div<{ themeColor: string; isCompactSafari?: boolean }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    padding-bottom: ${(p) =>
        p.isCompactSafari ? "calc(env(safe-area-inset-bottom, 0) + 32px)" : "0"};
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: ${(p) =>
            p.isCompactSafari ? "calc(24px + env(safe-area-inset-bottom, 0) + 16px)" : "24px"};
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    background-color: #ddd;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
                word-break: break-all;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
            .btn-redeem {
                margin-bottom: ${(p) =>
                    p.isCompactSafari ? "calc(env(safe-area-inset-bottom, 0) + 16px)" : "0"};
            }
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
            // background-color: lightgray;
            // border-color: lightgray;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    background-color: #ddd;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .content-product {
            margin-bottom: 10px;
            .topic-detail {
                text-align: left;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .layout-giftset {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                padding-left: 80px;
                margin-bottom: 15px;
                height: 135px;
                overflow: scroll;
                .img-giftset {
                    position: absolute;
                    top: 50%;
                    left: 12px;
                    transform: translateY(-50%);
                    img {
                        width: 52px;
                        height: 52px;
                        object-fit: contain;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 14px;
                        line-height: 17px;
                        color: #000;
                        font-weight: 600;
                        word-break: break-all;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #525257;
                        min-height: 30px;
                        word-break: break-word;
                    }
                }
            }
            p {
                font-size: 12px;
                color: #9b9b9b;
                color: red;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .countdownBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
        .disabled {
            background-color: #e1e1e1;
            border-color: #e1e1e1;
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
